(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nq-xsell-quickview"] && !Shopify.designMode) return;
  try {
    (function () {
    /* racine localisée : '/', '/fr/' ou '/de/' — jamais d'URL en dur (cf. incident R1/R24 du 25/09) */
    function nqRoot(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    function nqCartUrl(a){ return (nqRoot() + 'cart/' + a + '.js').replace('//','/'); }

    var qv = document.getElementById('nq-qv');
    if (!qv) return;
    var L = qv.dataset;
    window.__nqXsL = { added: L.lAdded, adding: L.lAdding, add: L.lAdd };
    var elImg   = qv.querySelector('[data-qv-img]');
    var elTitle = qv.querySelector('[data-qv-title]');
    var elPrice = qv.querySelector('[data-qv-price]');
    var elAdd   = qv.querySelector('[data-qv-add]');
    var elLink  = qv.querySelector('[data-qv-link]');
    var elOptW  = qv.querySelector('[data-qv-optwrap]');
    var elOpt   = qv.querySelector('[data-qv-opt]');
    var elErr   = qv.querySelector('[data-qv-err]');
    var lastFocus = null, current = null, reqId = 0, curSurface = 'pdp';
    var nqVariantImg = {}, imgFallback = '';

    /* l'image doit suivre la variante choisie — sinon on montre du doré en ayant selectionne Silver */
    function syncImg() {
      var u = nqVariantImg[String(elOpt.value)];
      elImg.src = u ? (location.protocol + u) : imgFallback;
    }

    /* Variantes : on les lit sur {racine}/products/{handle}.js — les libelles y sont en ANGLAIS
       quelle que soit la langue (l'endpoint .js de Shopify ne traduit pas), ce qui est accepte.
       En revanche le PRIX et le TITRE affiches viennent du DOM deja rendu par Liquid, donc deja
       traduits et deja dans la bonne devise : ne jamais afficher ceux du .js. */
    function loadVariants(handle, myId) {
      elOptW.hidden = true; elOpt.innerHTML = '';
      if (!handle) return;
      fetch((nqRoot() + 'products/' + handle + '.js').replace('//','/'))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || myId !== reqId) return;               /* une autre carte a ete ouverte entre-temps */
          var avail = (d.variants || []).filter(function (v) { return v.available; });
          if (avail.length < 2) return;                   /* une seule option : pas de selecteur */
          nqVariantImg = {};
          avail.forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.id; o.textContent = v.title;
            elOpt.appendChild(o);
            /* image propre a la variante : sans ca, choisir « Silver » laissait la photo dorée */
            var im = v.featured_image && (v.featured_image.src || v.featured_image);
            if (im) nqVariantImg[String(v.id)] = String(im).replace(/^https?:/, '');
          });
          elOptW.hidden = false;
          syncImg();
        })
        .catch(function () { /* silencieux : le bouton reste utilisable avec la variante par defaut */ });
    }

    function close(){
      qv.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      current = null;
    }

    function open(card, btn, surface){
      /* tout vient du DOM déjà rendu : titre et prix sont déjà traduits et déjà en devise locale */
      var img = card.querySelector('img');
      var a   = card.matches('a') ? card : card.querySelector('a[href*="/products/"]');
      /* .xs-title / .xs-price = cartes du tiroir · .nqc-card__* = cartes de la fiche produit */
      var t   = card.querySelector('.nqc-card__title, .nqc-card__name, .xs-title, h3, h4');
      var p   = card.querySelector('.nqc-card__price, .nqc-price, .xs-price, [class*="price"]');
      curSurface = surface || 'pdp';

      imgFallback = img ? (img.currentSrc || img.src) : '';
      elImg.src = imgFallback;
      nqVariantImg = {};
      elImg.alt = t ? t.textContent.trim() : '';
      elTitle.textContent = t ? t.textContent.trim() : '';
      /* on reordonne : prix courant d'abord, prix barre ensuite — quel que soit l'ordre d'origine */
      elPrice.innerHTML = '';
      if (p) {
        var now = p.querySelector('.nqc-card__now, .now');
        var was = p.querySelector('.nqc-card__was, .was');
        if (now || was) {
          if (now) elPrice.appendChild(now.cloneNode(true));
          if (was) elPrice.appendChild(was.cloneNode(true));
        } else { elPrice.innerHTML = p.innerHTML; }
      }
      elLink.textContent = L.lDetails;
      elLink.href = a ? a.getAttribute('href') : '#';
      elAdd.textContent = L.lAdd;
      elAdd.disabled = !btn;
      current = btn || null;
      reqId++;
      var h = card.getAttribute('data-nq-handle')
            || (a ? (a.getAttribute('href') || '').split('/products/')[1] : null);
      loadVariants(h ? h.split('?')[0].split('#')[0] : null, reqId);
      /* le tiroir n'a pas de lien produit : on masque « voir la fiche » plutot que de pointer nulle part */
      elLink.hidden = !a;

      lastFocus = document.activeElement;
      qv.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      elAdd.focus();
    }

    /* Deux surfaces, deux comportements d'origine differents :
       - FICHE PRODUIT (.nq-xsell) : la carte est un lien, elle faisait SORTIR de la page
         (190 clics sur 229 mesures). On intercepte pour retenir la cliente.
       - TIROIR PANIER (.nq-cd .xsell-card) : la carte n'est PAS un lien — verifie dans le balisage
         le 25/09, il n'y a aucun <a> dedans. Personne n'en sort donc. On ouvre quand meme la
         surcouche, pour une autre raison : laisser CHOISIR la couleur au lieu d'ajouter la
         premiere variante sans demander. */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nq-xs-add], [data-nq-cd-add], .nqc-card__sw')) return;  /* les boutons gardent leur ajout direct */

      var pdpCard = e.target.closest('.nq-xsell .nqc-card, .nq-xsell .nq-xsell__item a[href*="/products/"]');
      if (pdpCard) {
        var item = pdpCard.closest('.nq-xsell__item') || pdpCard.parentElement;
        e.preventDefault();
        open(item || pdpCard, item ? item.querySelector('[data-nq-xs-add]') : null, 'pdp');
        return;
      }
      var cdCard = e.target.closest('.nq-cd .xsell-card');
      if (cdCard) {
        e.preventDefault();
        open(cdCard, cdCard.querySelector('[data-nq-cd-add]'), 'cart');
      }
    });

    /* ajout : on réutilise la variante et le marquage du bouton existant */
    elOpt.addEventListener('change', syncImg);

    elAdd.addEventListener('click', function () {
      if (!current) return;
      /* si la cliente a choisi une variante, elle prime sur celle par defaut de la carte */
      var vid = (!elOptW.hidden && elOpt.value) ? elOpt.value
              : (current.getAttribute('data-nq-xs-add') || current.getAttribute('data-nq-cd-add'));
      if (!vid) return;
      var slot = current.getAttribute('data-nq-slot') || '';
      var anchor = current.getAttribute('data-nq-anchor') || '';
      elAdd.disabled = true;
      elErr.hidden = true;
      elAdd.textContent = L.lAdding;
      fetch(nqCartUrl('add'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1,
          properties: { '_upsell_src': curSurface + '|' + slot + '|' + anchor, '_upsell_v': 'v4-qv' } }] })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          elAdd.textContent = L.lAdded;
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          setTimeout(close, 700);
        })
        .catch(function () {
          /* rupture entre le rendu et le clic, ou 422 : sans message la cliente reclique dans le vide */
          elAdd.disabled = false; elAdd.textContent = L.lAdd;
          elErr.textContent = L.lError; elErr.hidden = false;
        });
    });


    /* ── INSTRUMENTATION (25/09) ─────────────────────────────────────────────────────────────
       Le pixel nq-site sait deja lire deux attributs poses par le theme :
         • [data-nq-track]  -> devient le LABEL de l'evenement de clic
         • [data-nq-block]  -> devient le BLOCK_ID de l'evenement de visibilite
       On s'en sert plutot que de modifier nq-site.liquid, qui est minifie.

       Ce qu'on ne savait PAS mesurer avant, et qu'on saura maintenant :
         1. le RANG de la carte cliquee — les achats le savaient deja (_upsell_src = pdp|3|ancre),
            mais pas les clics SANS achat : impossible de distinguer « la carte 4 n'interesse
            personne » de « la carte 4 n'est jamais vue ».
         2. la LARGEUR D'ECRAN — le pixel ne journalise que la hauteur (n3). Sans elle on ne peut
            pas savoir si le passage de 152px fixes a clamp(118px,38%,150px) a servi a quelque
            chose : il ne change rien au-dessus de 414px de large.
       Format du label : xs_c{rang}_{handle} · du block : xsell_track_w{tranche}
       ────────────────────────────────────────────────────────────────────────────────────── */
    function nqWBucket() {
      var w = window.innerWidth || 0;
      return w < 360 ? 'lt360' : w < 390 ? '360' : w < 414 ? '390' : w < 480 ? '414' : 'gte480';
    }
    function nqXsellStamp() {
      var wb = nqWBucket();
      /* garde-fou : l'observateur verrait ses propres ecritures et bouclerait */
      var todo = document.querySelector('.nq-xsell__item:not([data-nq-track]), .nq-cd .xsell-card:not([data-nq-track])');
      if (!todo && window.__nqStampW === wb) return;
      window.__nqStampW = wb;
      /* fiche produit */
      document.querySelectorAll('.nq-xsell__track').forEach(function (tr) {
        tr.setAttribute('data-nq-block', 'xsell_track_w' + wb);
        var items = tr.querySelectorAll('.nq-xsell__item');
        items.forEach(function (it, i) {
          var a = it.querySelector('a[href*="/products/"]');
          var h = a ? (a.getAttribute('href') || '').split('/products/')[1] : '';
          h = (h || '').split('?')[0].split('#')[0];
          it.setAttribute('data-nq-track', 'xs_c' + (i + 1) + '_' + h);
          it.setAttribute('data-nq-kind', 'content');
        });
      });
      /* tiroir panier */
      document.querySelectorAll('.nq-cd .xsell-row').forEach(function (tr) {
        tr.setAttribute('data-nq-block', 'cdxs_track_w' + wb);
        tr.querySelectorAll('.xsell-card').forEach(function (c, i) {
          c.setAttribute('data-nq-track', 'cdxs_c' + (i + 1) + '_' + (c.getAttribute('data-nq-handle') || ''));
          c.setAttribute('data-nq-kind', 'content');
        });
      });
    }
    nqXsellStamp();
    /* Le tiroir est re-rendu par l'API Section Rendering : un simple setTimeout apres `cart:build`
       marquait trop tot (cartes encore absentes du DOM, releve du 25/09 : data-nq-track = null).
       On observe donc les mutations et on re-marque, en debounce. */
    var stampT;
    function stampSoon() { clearTimeout(stampT); stampT = setTimeout(nqXsellStamp, 120); }
    new MutationObserver(stampSoon).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:build', stampSoon);
    document.addEventListener('shopify:section:load', stampSoon);
    window.addEventListener('resize', stampSoon);

    qv.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) close(); });

    /* Piege de focus propre a la modale, en CAPTURE : le tiroir en a un qui rapatriait le focus
       chez lui des la premiere tabulation, rendant le selecteur de variante inatteignable. */
    document.addEventListener('keydown', function (e) {
      if (qv.hidden || e.key !== 'Tab') return;
      e.stopPropagation();
      var f = qv.querySelectorAll('button:not([disabled]), select, a[href]:not([hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !qv.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    }, true);
    /* capture + stopPropagation : sinon le meme Echap fermait AUSSI le tiroir panier,
       qui a son propre ecouteur sur document (nq-cart-drawer.liquid). */
    document.addEventListener('keydown', function (e) {
      if (qv.hidden || e.key !== 'Escape') return;
      e.stopPropagation(); e.preventDefault();
      close();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
